import React, {useState, useCallback, useContext} from 'react';

export const MessageContext = React.createContext({
  message: null,
  addMessage: () => {},
  addErrorMessage: () => {},
  removeMessage: () => {}
});

export default function MessageProvider({ children }) {
  const [message, setMessage] = useState(null);

  const removeMessage = () => setMessage(null);

  const addMessage = (message, status, title) => setMessage({ message, status, title });
  const addErrorMessage = (message, status, title) => setMessage({ message, status, title });

  return (
    <MessageContext.Provider value={{
      message,
      addMessage: useCallback((message, status="info", title) => addMessage(message, status, title), []),
      addErrorMessage: useCallback((message, status="danger", title="Nastala chyba :(") => addMessage(message, status, title), []),
      removeMessage: useCallback(() => removeMessage(), [])
    }}>
      {children}
    </MessageContext.Provider>
  );
}

export function useGlobalNotificationMessage() {
  const {message, addMessage, addErrorMessage, removeMessage, ...context} = useContext(MessageContext);
  return {
    message,
    addMessage,
    addErrorMessage,
    removeMessage
  };
}
